import EventManager from './eventManager';

export default EventManager;